import { apiEndpoints } from '../constants/apiEndpoints';
import Service from './service';

const GetDealerships = async () => {
  try {
    const res = await Service.get(apiEndpoints.GET_DEALERSHIPS);
    return res;
  } catch (error) {
    return error;
  }
};
export default GetDealerships;
